import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=14062d74&"
import script from "./Step2.vue?vue&type=script&lang=ts&"
export * from "./Step2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports